/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Funzione per controllare se l'URL contiene il parametro ?app=true
  function isAppMode() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('app') === 'true';
  }

  // Se il parametro ?app=true è presente, aggiungi una classe al body
  if (isAppMode()) {
    document.body.classList.add('app-true');
  }

  // Nascondi il banner cookie se siamo in modalità app
  if (document.body.classList.contains('app-true')) {
    const cookieBanner = document.querySelector('.pd-cookie-banner-window.cc-window');
    if (cookieBanner) {
      cookieBanner.style.display = 'none';
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
  // Funzione per estrarre il brand dai tag
  function extractBrandFromTags(tags, brandList) {
    for (let tag of tags) {
      for (let brand of brandList) {
        if (tag.toLowerCase() === brand.toLowerCase()) {
          return brand;
        }
      }
    }
    return null;
  }

  // Seleziona l'elemento dove mostrare il brand
  const productBrandElement = document.getElementById('product-brand');

  if (productBrandElement && Shopify) {
    const productTags = Shopify.product.tags; // Verifica che i tag siano accessibili tramite un oggetto globale di Shopify
    const brandList = ["Nike", "Adidas", "Puma", "Reebok"]; // Aggiorna con i brand pertinenti

    const brandFound = extractBrandFromTags(productTags, brandList);

    if (brandFound) {
      productBrandElement.textContent = brandFound;
    }
  }
});

  // Altri script personalizzati...
})();